import "zone.js";
import {getAppStatus, registerApplication, start} from "single-spa";
import {constructApplications, constructLayoutEngine, constructRoutes} from "single-spa-layout";
import {createFooter} from './utils';
import Token from './shared-modules/token';
import Storage from './shared-modules/storage';
import { eventBus } from './shared-modules/event-bus';
import {initRoutingEventsManager} from "./core/permissions-manager";

//STORAGE E IMPORTMAP
const appPrefix = '@muapp';
const storage = new Storage('bootstrap');

//AUTENTICAZIONE e AUTORIZZAZIONE
const token = new Token();
const tenant = /:\/\/([^\/]+)/.exec(window.location.href)[1].split('.')[0];

async function loadConfigs() {
  const configs = (await fetch('/configs')).json();
  console.log('loadConfigs', configs);
  return configs;
}


function getAppsRoutes(props, apps) {
  return apps.map((appName: any) => {
    console.debug(`preparing ${appPrefix}/${appName}`)
    return {
      type: "route",
      path: `/${appName}`,
      routes: [
        {
          type: "application",
          name: `${appPrefix}/${appName}`,
          props: {
            ...props,
            storage: new Storage(appName),
          }
        }
      ]
    };
  });
}

function initSidenavEventManager(eventBus: any) {
  // events
  const sidenav = document.getElementsByClassName("main-container-sidenav");
  const mfContent = document.getElementsByClassName("mat-sidenav-content");
  const footer = document.getElementById("footer-container");
  eventBus.on('toggle:sidenav', (event: any) => {
    if (sidenav[0].classList.value.includes('open')) {
      sidenav[0].classList.remove('open');
      sidenav[0].classList.add('close');

      createFooter(false);

      mfContent[0].classList.remove('content-with-sidenav');
      mfContent[0].classList.add('content-without-sidenav');
    } else {
      sidenav[0].classList.remove('close');
      sidenav[0].classList.add('open');

      createFooter(true);

      mfContent[0].classList.remove('content-without-sidenav');
      mfContent[0].classList.add('content-with-sidenav');
    }
  });
}

(async () => {
  if (localStorage.getItem('token')) {
    initSidenavEventManager(eventBus);
    try {
      const {importMap, suiteConfigs, suitesList, headerConfigs, sidenavConfigs, externalUrl} = await loadConfigs();
      const tenantInMaintenance = suiteConfigs.maintenance.filter(sc => sc.tenant.includes(tenant));
      if(tenantInMaintenance.length > 0) {
        const start = new Date(tenantInMaintenance[0].start);
        const end = new Date(tenantInMaintenance[0].end);
        const now = new Date();
        if(now > start && now < end) {
          window.location.replace('/maintenance?query=' + window.location.pathname);
        }
      }
      const appsList = Object.keys(importMap.imports)
        .filter(app => app.indexOf(appPrefix) >= 0)
        .map(str => str.replace(`${appPrefix}/`, ''));

      const resultAuth = await token.getAuth();
      const resultAuthFE = await token.getAuthFE();
      const resultAuthManuals = await token.getManuals();

      token.auth = resultAuth;
      token.authFE = resultAuthFE;
      window.localStorage.setItem('manuals', JSON.stringify(resultAuthManuals));

      if (!!resultAuth && !!resultAuthFE) {
        initRoutingEventsManager(appPrefix, eventBus, suitesList, resultAuth);
        const sharedProps = {
          suiteConfigs,
          suitesList,
          eventBus: eventBus,
          token: token,
          tenant: /:\/\/([^\/]+)/.exec(window.location.href)[1].split('.')[0],
          externalUrl:externalUrl
        }


        let urlSplitted = window.location.href.split("/")
        let nUrlSplitted = urlSplitted.length
        let serviceRequested = urlSplitted[3]
        if(nUrlSplitted >= 5) {
          if (resultAuth[serviceRequested] === undefined) {
            window.location.replace('/home' );
          }
        }

        const routesConfig = {
          routes: [
            {
              type: 'nav',
              attrs: [{'name': 'class', 'value': 'main-container-header'}],
              routes: [{
                type: 'application',
                name: 'header',
                props: {
                  headerConfigs,
                  externalUrl,
                  ...sharedProps,
                  bootstrap: storage.container,
                  storage: new Storage('header')
                }
              }]
            },
            {
              type: 'aside',
              attrs: [{'name': 'class', 'value': 'main-container-sidenav open'}],
              routes: [{
                type: 'application',
                name: 'sidenav',
                props: {
                  sidenavConfigs,
                  externalUrl,
                  ...sharedProps,
                  bootstrap: storage.container,
                  storage: new Storage('sidenav')
                }
              }]
            },
            ...getAppsRoutes(sharedProps, appsList)
          ]
        };
        const routes = constructRoutes(routesConfig);
        const applications = constructApplications({
          routes,
          // @ts-ignore
          loadApp: app => System.import(app.name)
        });

        console.debug("routes", routes);
        console.debug("applications", applications);

        const layoutEngine = constructLayoutEngine({routes, applications});
        applications.forEach(registerApplication);
        layoutEngine.activate();

        start();

      }

    } catch (error) {
      console.error(error);
    }
  } else {
    localStorage.removeItem('cache-cleared')
    window.location.replace('/welcome?query=' + window.location.pathname);
  }
})();



/**
 *
 * @return {boolean}
 */
export function isLogged() {
  let currentStatus = storage.storageLength;
  console.debug("current login status", currentStatus, !!currentStatus);
  return !!currentStatus;
}

window.addEventListener('single-spa:before-routing-event', event => {
  let appToMount = window.location.pathname.split('/')[1];
  const over = document.getElementById("overlay");
  appToMount = (!['header, sidenav'].includes(appToMount)) ? `${appPrefix}/${appToMount}`: appToMount;
  console.debug(`Mounting: ${appToMount} current status: ${getAppStatus(appToMount)}  event.detail: `, JSON.stringify(event));
  if (getAppStatus(appToMount) === 'MOUNTED') {
    const mfContent = document.getElementsByClassName("mat-sidenav-content");
    if(mfContent.length && mfContent[0].classList.value.indexOf('content-w') < 0) {
      mfContent[0].classList.add('content-with-sidenav');
    }
    createFooter(true);
    setTimeout(() => {
      over.classList.remove("show");
    }, 1500)
  }
});


// window.addEventListener('single-spa:app-change', event => {
//   console.log('A routing event occurred where at least one application was mounted/unmounted', event);
// });

// window.addEventListener('single-spa:before-routing-event', event => {
//   console.log('A routing event occurred where zero applications were mounted/unmounted', event);
// });

// window.addEventListener('single-spa:before-first-mount', () => {
//   console.log('single-spa is about to mount the very first application for the first time');
// });

// window.addEventListener('single-spa:first-mount', () => {
//   console.log('single-spa just mounted the very first application');
// });
